export default "__VITE_ASSET__Ct_RmFhA__"